import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { infoButton_template }  from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";


declare var ko: any;

export class configCategoriesList_template extends vnTemplate{

    public simpleFilter: filterSimple_template;
    public resultsInfo: resultsInfo_template;
    public pagination: pagination_template;
    protected selectableCategoriesPageTooltip: infoButton_template;
    protected selectableCategoriesPageTooltipContent;

    protected getTemplateHtml(): string{

        //data-bind="css: { loading: isLoading }"
        return  `  
                <div class="list-header w-justify">
                    <div class="w-left">
                        <div class="form-check-inline">
                            <div class="form-group row">
                                <input type="checkbox" data-bind="checked: isShowSelectableCategories, click: showActiveCategories" id="showActiveCategory">
                                <label for="showActiveCategory" class="form-label icon i-check">Show categories available for use</label>   
                                <div class="w-tooltips-adv pos-bottom short">
                                    ` + this.selectableCategoriesPageTooltip.getHtmlBuild() + `
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="w-center"> 
                        ` + this.simpleFilter.getHtmlBuild() + `
                    </div>
                    
                    <div class="w-right">
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
                </div>
                
                 <div class="w-list-results" id="list-results">
                   <table class="list-results">
                    ` + this.resultsInfo.getHtmlBuild() + `
                        <thead>
                            <input data-bind="value: orderBy" type="hidden">
                            <input data-bind="value: orderByDirection" type="hidden">
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }" class="icon i-dropdown-simple">id</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }" class="icon i-dropdown-simple">name</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': orderByAndDirection()=='articleCount_DESC', 'list-sort-asc': orderByAndDirection()=='articleCount_ASC' }" class="icon i-dropdown-simple">Article Count</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isSelectable') }, css: { 'list-sort-desc': orderByAndDirection()=='isSelectable_DESC', 'list-sort-asc': orderByAndDirection()=='isSelectable_ASC' }" class="icon i-dropdown-simple">Available for Use</span></th>

                            </tr>
                        </thead>
                        <tbody data-bind="foreach: categories">
                            <tr class="cursor" >
                                <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: id"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: name"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: articleCount"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: isSelectable"></span></a></td>
                            </tr>
                        <tbody>
                    </table>
                </div>
            `;

    }

    // implementation of base class [vnTemplate]
    protected initPartial(): void {

        this.simpleFilter = new filterSimple_template("simpleFilter", this.getTemplateViewModel(), this.caller);
        this.resultsInfo = new resultsInfo_template("resultsInfo", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.selectableCategoriesPageTooltipContent = `
        <p>
        Use this to show/hide categories that have been made available for a brand to use.
        </p>
        `
        this.selectableCategoriesPageTooltip = new infoButton_template('selectableCategoriesPageTooltip', this.getTemplateViewModel(), this.caller)
        this.selectableCategoriesPageTooltip.setTitle('Show categories available for use');
        this.selectableCategoriesPageTooltip.setContent(this.selectableCategoriesPageTooltipContent);
    }


    protected getTemplateName(): string{
        return "configCategories-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-content"];
    }

    protected buildViewModel(): any{

        let self = this;
        return  {
            orderBy: ko.observable("name"),
            orderByAndDirection: ko.observable("name_ASC"),
            orderByDirection: ko.observable("ASC"),
            categories: ko.observableArray([]),
            isShowSelectableCategories: ko.observable(false),
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickView: function (value) {
                self.onClickView(value);
            },
            showActiveCategories: function (data) {
                self.showActiveCategories();
                return true;
            }
        };
    }

    public getViewModelForRequest(){

        return {
            orderBy: this.getTemplateViewModel().orderBy
            ,orderByDirection: this.getTemplateViewModel().orderByDirection
            ,orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            //,filter : this.getTemplateViewModel().simpleFilter.
            ,filter : {
                keyword: this.getTemplateViewModel().simpleFilter.filterKeyword,
                isShowSelectableCategories : this.getTemplateViewModel().isShowSelectableCategories
            }
            ,pagination: this.getTemplateViewModel().pagination
        }
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.categoryListReorder();
    }

    public setCategories(categories) {

        this.getTemplateViewModel().categories(categories);
    }

    public onClickView(value) {

        this.caller.viewCategory(value.id);
    }

    public showActiveCategories(){

        this.caller.onShowActiveCategories();
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/configCategoriesList_template.ts